<swiper-container [passedParams]="slideOpts">
  <swiper-slide *ngFor="let image of imageList">
    <div class="relative flex flex-col gap-8 rounded-xl max-w-[326px] md:max-w-[226px]">
      <div class="absolute top-4 right-4">
        <fun-icon [name]="'user-x'" [style]="'w-24 h-24 stroke-[2px] stroke-[#E64937]'"></fun-icon>
      </div>
      <img [src]="image.url" />
      <div class="flex flex-col items-center content-center">
        <p class="font-sansLight text-m text-eggplant-80 leading-[1.35]">{{ image.text }}</p>
      </div>
    </div>
  </swiper-slide>
</swiper-container>
